import * as z from 'zod';

import { industryQuerySchema } from './industry-query-schema';

export const industryUpdateSchema = industryQuerySchema
  .pick({
    id: true,
    name: true,
    consumer_label: true,
    description: true,
    parent_id: true,
  })
  .extend({
    status: z.string(),
  });

export type IndustryUpdateSchema = z.infer<typeof industryUpdateSchema>;

export const industryCreateSchema = industryUpdateSchema.omit({
  id: true,
});

export type IndustryCreateSchema = z.infer<typeof industryCreateSchema>;
